import { render } from "./AdminCollecTable.vue?vue&type=template&id=ef95edc0&scoped=true"
import script from "./AdminCollecTable.vue?vue&type=script&lang=js"
export * from "./AdminCollecTable.vue?vue&type=script&lang=js"

import "./AdminCollecTable.vue?vue&type=style&index=0&id=ef95edc0&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-ef95edc0"]])

export default __exports__